// RUN BUILD WITH: ng build --configuration=dev

export const environment = {
  production: false,
  url: 'https://devcms.job.rocks/',
  apiUrl: 'https://devcms.job.rocks/api',
  ibanApi: "https://services.job.rocks/",
  chatUrl: "http://localhost:3000/",
  chatApiUrl: "http://localhost:3000/api",

  iosAppLink: "https://apps.apple.com/us/app/job-rocks/id1448473856",
  androidAppLink: "https://play.google.com/store/apps/details?id=com.sihp.jobrocks",

  // jobrocks
  logoUrl: "assets/images/job.rocks-grey-logo.svg",
  favIconUrl: "assets/images/icons/job.rocks.favicon.svg",
  agencyName: "jobrocks",

  // monitoring
  sentryDsn: 'https://3af19c63fd69f6191da152fcb513d320@o4511032735039488.ingest.de.sentry.io/4511038077534288',
  sentryEnvironment: 'dev',
};
